export default {
    'day-of-week': 'Dzień tygodnia',

    // Do not reorder these in alphabetical order
    'monday': 'Poniedziałek',
    'tuesday': 'Wtorek',
    'wednesday': 'Środa',
    'thursday': 'Czwartek',
    'friday': 'Piątek',
    'saturday': 'Sobota',
    'sunday': 'Niedziela'
}
